
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/luggage-storage-for-business-travelers",
      function () {
        return require("private-next-pages/luggage-storage-for-business-travelers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/luggage-storage-for-business-travelers"])
      });
    }
  